import { useLang } from '../../../i18n/LangContext';

export default function Testimonials() {
  const { t } = useLang();

  const testimonials = [
    {
      name: 'Георги Петров',
      position: 'Изпълнителен директор, Tech Solutions',
      country: 'България',
      text: 'Алекс трансформира нашата инвестиционна стратегия. Неговият анализ на пазара и препоръки доведоха до 35% ръст на нашия портфейл за една година. Професионализмът и експертизата му са безценни.'
    },
    {
      name: 'Мария Иванова',
      position: 'Предприемач',
      country: 'Германия',
      text: 'Работата с Алекс е истинско удоволствие. Той не само анализира цифрите, но и обяснява сложните концепции по разбираем начин. Благодарение на неговите съвети, успях да диверсифицирам портфейла си ефективно.'
    },
    {
      name: 'Джон Смит',
      position: 'Инвестиционен мениджър',
      country: 'Великобритания',
      text: 'Познавам Алекс от времето му в HSBC. Неговата способност да предвижда пазарни тенденции и да идентифицира възможности е изключителна. Един от най-добрите анализатори, с които съм работил.'
    },
    {
      name: 'Анна Ковалева',
      position: 'Собственик на бизнес',
      country: 'Русия',
      text: 'Алекс ми помогна да навигирам през сложните международни пазари. Неговият стратегически подход и внимание към детайлите осигуриха стабилна възвръщаемост дори в турбулентни времена.'
    },
    {
      name: 'Карлос Родригес',
      position: 'Финансов директор',
      country: 'Испания',
      text: 'Дълбокото познаване на глобалните пазари от страна на Алекс и способността му да анализира макроикономически тенденции са невероятни. Препоръчвам го на всеки, който търси професионален финансов съвет.'
    },
    {
      name: 'Лий Чен',
      position: 'Инвеститор',
      country: 'Китай',
      text: 'Работя с Алекс от 5 години и резултатите говорят сами за себе си. Неговият технически анализ и разбиране на японските свещи са на световно ниво. Изключително доволен от сътрудничеството.'
    }
  ];

  return (
    <section id="testimonials" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
            {t('test_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">{t('test_subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-8 rounded-2xl border border-[#d4af37]/20 hover:border-[#d4af37]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#d4af37]/10 hover:-translate-y-1"
            >
              <div className="mb-6">
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#d4af37] text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-300 leading-relaxed italic">"{testimonial.text}"</p>
              </div>
              <div className="border-t border-[#d4af37]/20 pt-6">
                <div className="font-semibold text-[#d4af37] text-lg">{testimonial.name}</div>
                <div className="text-sm text-gray-400 mt-1">{testimonial.position}</div>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-map-pin-line text-[#d4af37]"></i>
                  <span className="text-sm text-gray-400">{testimonial.country}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
